import Request from './request'

const Dashboard = {
  dashboardIndex (callback) {
    Request.get('dashboard/index').then(callback).catch(this.bad_answer)
  },
  dashboardDeviceMap (params, callback) {
    Request.get('dashboard/device-map', params).then(callback).catch(this.bad_answer)
  },
  dashboardDeviceMapDetails (params, callback) {
    Request.get('dashboard/device-map-details', params).then(callback).catch(this.bad_answer)
  },
  dashboardDeviceInfo(fid, callback){
    Request.get('dashboard/device-view/' + fid).then(callback).catch(this.bad_answer)
  },
  dashboardStats (callback) {
    Request.get('dashboard/stats').then(callback).catch(this.bad_answer)
  },
  dashboardDeviceTraffic (params, callback) {
    Request.get('dashboard/device-traffic', params).then(callback).catch(this.bad_answer)
  },
  dashboardSimcardsTraffic (params, callback) {
    Request.get('dashboard/simcards-traffic', params).then(callback).catch(this.bad_answer)
  },
  dashboardUnlimitedTraffic (callback) {
    Request.get('dashboard/device-unlim-traffic').then(callback).catch(this.bad_answer)
  },
}
export default Dashboard
